import {Component, OnInit} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-field-editor-unsaved-changes',
  templateUrl: './field-editor-unsaved-changes.component.html',
  styleUrls: ['./field-editor-unsaved-changes.component.scss'],
  animations: [
    trigger('changes', [
      state('void', style({
        transform: 'translateY(-150%)'
      })),
      transition('void => *', animate(250))
    ])
  ]
})
export class FieldEditorUnsavedChangesComponent implements OnInit {
  changesButtonOptions: any;
  changesPopupVisible: boolean;

  constructor() {

    this.changesButtonOptions = {
      icon: 'save',
      text: 'Changements',
      onClick: () => {
        this.changesPopupVisible = !this.changesPopupVisible;
      }
    };
  }

  ngOnInit(): void {
  }

}
